// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b7c98358","498":"9868c2e1","703":"390557ee","787":"85041a26"}[chunkId] + ".chunk.js";
};